var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A5C",
    d: "M5.2.148a.834.834 0 00-1.133 1.119A6.8 6.8 0 014.092 7.4a.166.166 0 01-.291-.003 3.723 3.723 0 01-.374-1.046.503.503 0 00-.802-.291 5.769 5.769 0 00-1.854 6.4 5.205 5.205 0 005.166 3.49c2.819 0 4.79-1.43 5.41-3.922.92-3.678-1.336-9.33-6.147-11.88zm3.158 11.919a2.21 2.21 0 01-2.339 1.886 2.27 2.27 0 01-2.236-1.874.333.333 0 01.404-.384 2.004 2.004 0 001.667-.94 1.534 1.534 0 00.302-1.64.333.333 0 01.407-.475 3.15 3.15 0 011.795 3.427z"
  })));
}
export default SvgFlame;